<ng-template #template>
  <div #bsModal (onHide)="hideHandler($event)">
    <div class="modal-header">
      <ng-content select="[modal-title]"></ng-content>
      <button class="close ls1-hidden" (click)="hide()">
        <span>×</span>
      </button>
      <div class="close ls2-hidden" (click)="hide()">
        <i class="icon-16-close-white"></i>
      </div>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <ng-content select="[modal-body]"></ng-content>
    </div>


    <!-- Default Footer -->
    <div class="modal-footer" *ngIf="!lpRequest && !useCustomFooter && !hideFooter">
      <button
        class="btn-link cancel-link"
        *ngIf="showCancel"
        (click)="hide()">
        Cancel
      </button>
      <div class="modal-action-content">
        <ng-content select="[modal-action]"></ng-content>
        <button
          *ngIf="!hideDefaultButton"
          type="button"
          class="done-button btn btn-sm btn-inverse pull-right"
          aria-label="Done"
          (click)="hide()">
          <span aria-hidden="true">Done</span>
        </button>
      </div>
    </div>

    <div class="modal-footer" *ngIf="useCustomFooter">
      <ng-content select="[modal-footer]"></ng-content>
    </div>

    <!-- LP Request Footer -->
    <div
      class="modal-action lpRequest pull-right"
      *ngIf="lpRequest && !useCustomFooter">
      <div class="modal-action-content">
        <ng-content select="[modal-action]"></ng-content>
        <a
          [routerLink]="['/borrower/' + borrowerId]"
          type="button"
          class="done-button btn btn-primary pull-right"
          aria-label="View business">
          <span aria-hidden="true">View Business</span>
        </a>
        <button
          *ngIf="!hideDefaultButton"
          type="button"
          class="done-button btn btn-default pull-right"
          aria-label="Done"
          (click)="hide()">
          <span aria-hidden="true">Close</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
